export const COOKIE_KEYS = Object.freeze({
    USER: 'userToken', // <id>_<hash>
    SELLER: 'sellerToken', // <VERTICAL PREFIX>_<id>_<hash>
    MASQUERADE_BUYER: 'masqueradeBuyer', // U_<id>
    MASQUERADE_BUYER_USER_TOKEN: 'masqueradeBuyerUserToken',
    MASQUERADE_SELLER: 'masqueradeSeller', // S_<id>_<VERTICAL PREFIX>
    USER_TYPE: 'userType',
    REAL_USER_TYPE: 'realUserType',
    USER_EMAIL: 'userEmail',
    USER_EMAIL_TOKEN: 'userEmailToken',
    USER_LEGACY: 'userreg',
    GUEST_ID: 'guestId',
    EVER_LOGGED_IN: 'eli',
    PASSWORD_RESET: 'passwordToken',
    AB_TEST_ELIGIBILITY: 'abe',
});
